import { render, staticRenderFns } from "./userProfileSidebar.vue?vue&type=template&id=31a51f11&scoped=true&"
import script from "./userProfileSidebar.vue?vue&type=script&lang=js&"
export * from "./userProfileSidebar.vue?vue&type=script&lang=js&"
import style0 from "./userProfileSidebar.vue?vue&type=style&index=0&id=31a51f11&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31a51f11",
  null
  
)

export default component.exports